import { render, staticRenderFns } from "./DepartmentTeamList.vue?vue&type=template&id=7e53fd10"
import script from "./DepartmentTeamList.vue?vue&type=script&lang=js"
export * from "./DepartmentTeamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports